/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { WebRoutePath } from "./routePath";
import { NotFound } from "#pages";
import { Sidebar, SidebarTab } from "#components";
import { AuthContext } from "#contexts/authContext.jsx";
import webSidebarConfig from "#constants/webSidebarConfig.js";

export default function WebRouter() {
  const { isAuthenticated } = useContext(AuthContext);

  const PublicRoute = () => {
    if (isAuthenticated === true) {
      return <Navigate to={WebRoutePath.DASHBOARD.path} replace />;
    }
    return <Outlet />;
  };

  const ProtectedRoute = () => {
    if (isAuthenticated === false) {
      return <Navigate to={"/"} />;
    }
    return (
      <>
        <Sidebar>
          {webSidebarConfig().map((item) => (
            <SidebarTab data={item} />
          ))}
        </Sidebar>
        <Outlet />
      </>
    );
  };

  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route index element={WebRoutePath.SPLASH.component} />
        <Route
          path={WebRoutePath.SPLASH.path}
          element={WebRoutePath.SPLASH.component}
        />
        <Route
          path={WebRoutePath.LOGIN.path}
          element={WebRoutePath.LOGIN.component}
        />
        <Route
          path={WebRoutePath.FORGOT_PASSWORD.path}
          element={WebRoutePath.FORGOT_PASSWORD.component}
        />
        <Route
          path={WebRoutePath.VERIFY_OTP.path}
          element={WebRoutePath.VERIFY_OTP.component}
        />
        <Route
          path={WebRoutePath.RESET_PASSWORD.path}
          element={WebRoutePath.RESET_PASSWORD.component}
        />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route
          path={WebRoutePath.DASHBOARD.path}
          element={WebRoutePath.DASHBOARD.component}
        />
        <Route
          path={WebRoutePath.CHANGE_PASSWORD.path}
          element={WebRoutePath.CHANGE_PASSWORD.component}
        />
        <Route
          path={WebRoutePath.PROFILE.path}
          element={WebRoutePath.PROFILE.component}
        />

        {/* GROWER ROUTES */}
        <Route
          path={WebRoutePath.GROWER_MANAGEMENT.path}
          element={WebRoutePath.GROWER_MANAGEMENT.component}
        />
        <Route
          path={WebRoutePath.GROWER_DETAIL.path}
          element={WebRoutePath.GROWER_DETAIL.component}
        />
        {/* SCOUTING ROUTES */}
        <Route
          path={WebRoutePath.SCOUTING_MANAGEMENT.path}
          element={WebRoutePath.SCOUTING_MANAGEMENT.component}
        />
        <Route
          path={WebRoutePath.SCOUTING_DETAIL.path}
          element={WebRoutePath.SCOUTING_DETAIL.component}
        />
        {/* CROP PLAN ROUTES */}
        <Route
          path={WebRoutePath.CROP_PLAN_MANAGEMENT.path}
          element={WebRoutePath.CROP_PLAN_MANAGEMENT.component}
        />
        <Route
          path={WebRoutePath.ADD_CROP_PLAN_MANAGEMENT.path}
          element={WebRoutePath.ADD_CROP_PLAN_MANAGEMENT.component}
        />
        <Route
          path={WebRoutePath.EDIT_CROP_PLAN_MANAGEMENT.path}
          element={WebRoutePath.EDIT_CROP_PLAN_MANAGEMENT.component}
        />
        <Route
          path={WebRoutePath.CROP_PLAN_DETAIL.path}
          element={WebRoutePath.CROP_PLAN_DETAIL.component}
        />
        {/* FIELD ROUTES */}
        <Route
          path={WebRoutePath.FIELD_MANAGEMENT.path}
          element={WebRoutePath.FIELD_MANAGEMENT.component}
        />
        <Route
          path={WebRoutePath.FIELD_MANAGEMENT_DETAIL.path}
          element={WebRoutePath.FIELD_MANAGEMENT_DETAIL.component}
        />
        {/* CONTENT MANAGEMENT */}
        <Route
          path={WebRoutePath.PRIVACY_POLICY.path}
          element={WebRoutePath.PRIVACY_POLICY.component}
        />
        <Route
          path={WebRoutePath.TERMS_CONDITIONS.path}
          element={WebRoutePath.TERMS_CONDITIONS.component}
        />
        <Route
          path={WebRoutePath.ABOUT_US.path}
          element={WebRoutePath.ABOUT_US.component}
        />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
